import { render, staticRenderFns } from "./SchedulingEventCreate.vue?vue&type=template&id=3b8a7142"
import script from "./SchedulingEventCreate.vue?vue&type=script&lang=js"
export * from "./SchedulingEventCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports